import BaseRequest from './BaseRequest';

const schema = 'campaign';
/**
 * key base on host:port
 */
export default class Campaign extends BaseRequest {
  /**
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchAllCampaigns(params) {
    const url = `${schema}/campaigns`;
    return this.get(url, params);
  }
}
